import axios from 'axios'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import Spinner from '../usables/small/Spinner'
import ClosingAlert from '../usables/Alert'
import Input from '../usables/small/Input'
import Button from '../usables/small/ButtonReal'
import Card from '../usables/small/Card'

export default function StudentAssignment() {
  const { slug } = useParams();
  const [dataLoaded, setDataLoaded] = useState({isLoading: false, sucssess: false})
  const [formData, setFormData] = useState({slug: slug, password: ''})
  const [studentInfo, setStudentInfo] = useState({})
  const [showError, setShowError] = useState(false)

  const getStudent = () => {
    setDataLoaded({isLoading: true, sucssess: false})
    axios.post(process.env.REACT_APP_API + '/msc/getnotification', formData)
    .then(res => {
      if(res.status === 200){
        // console.log(res.data.subject.teacher)
        setStudentInfo([]) //! Pašalinti prieš buildinant
        setStudentInfo(res.data.notification)
        setDataLoaded({isLoading: false, sucssess: true})
      }
    })
    .catch(err => {
      setShowError(true)
      setStudentInfo(err.response.data)
      setDataLoaded({isLoading: false, sucssess: false})
    })
  }

  return (
    <>
      {/* <ClosingAlert type='error' message='Neteisingas slaptažodis' show={showError} updateState={(value) => {setShowError(value)}} /> */}
      {!dataLoaded.sucssess
      ? dataLoaded.isLoading
        ? <Spinner />
        : <div className='w-full h-95 flex items-center justify-center m-auto'>
            <div className='max-w-md w-full m-auto mt-48 p-5 bg-white border rounded'>
              <ClosingAlert type='error' message='Neteisingas slaptažodis' show={showError} updateState={(value) => {setShowError(value)}} />
              <h2 className='font-medium text-xl'>Sužinoti klasės priskyrimą</h2>
              <form className='pt-5' onSubmit={getStudent}>
                <Input
                    label='Slaptažodis'
                    name='password'
                    type='password'
                    value={formData.password}
                    onChange={(e)=>setFormData({...formData, password: e.target.value})}
                />
                <Button text='Sužinoti klasę' />
              </form>
            </div>
          </div>
      : <>
        <div className='w-full h-[85vh] flex items-center justify-center m-auto'>
          <Card title={studentInfo.student.person.name + ' ' + studentInfo.student.person.lastname}>
            <p>Moksleivis paskirtas į {studentInfo.student.student_class.name} klasę</p>
          </Card>
        </div>
        
        </>
      }
    </>
  )
}